// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Modal_buttonContainer__h9M4k","button":"Modal_button__KX3v4"};